var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1F21",
    fillRule: "evenodd",
    clipPath: "url(#sun_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.7a4.3 4.3 0 1 0 0 8.6 4.3 4.3 0 0 0 0-8.6ZM6.8 12a5.7 5.7 0 1 1 11.4 0 5.7 5.7 0 0 1-11.4 0ZM12.5.3a.7.7 0 0 1 .7.7v2a.7.7 0 1 1-1.4 0V1a.7.7 0 0 1 .7-.7Zm0 20a.7.7 0 0 1 .7.7v2a.7.7 0 1 1-1.4 0v-2a.7.7 0 0 1 .7-.7ZM4.225 3.725a.7.7 0 0 1 .99 0l1.42 1.42a.7.7 0 0 1-.99.99l-1.42-1.42a.7.7 0 0 1 0-.99Zm14.14 14.14a.7.7 0 0 1 .99 0l1.42 1.42a.7.7 0 1 1-.99.99l-1.42-1.42a.7.7 0 0 1 0-.99ZM.8 12a.7.7 0 0 1 .7-.7h2a.7.7 0 1 1 0 1.4h-2a.7.7 0 0 1-.7-.7Zm20 0a.7.7 0 0 1 .7-.7h2a.7.7 0 1 1 0 1.4h-2a.7.7 0 0 1-.7-.7ZM6.635 17.865a.7.7 0 0 1 0 .99l-1.42 1.42a.7.7 0 1 1-.99-.99l1.42-1.42a.7.7 0 0 1 .99 0Zm14.14-14.14a.7.7 0 0 1 0 .99l-1.42 1.42a.7.7 0 1 1-.99-.99l1.42-1.42a.7.7 0 0 1 .99 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sun_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgSun;